export const step1intro = {
    id: 1,
    title: 'Úvod do hry',
    taskText: `
        <p>
            Přejeme hodně štěstí během naší Šifrovací hry! Myslete prosím na to, že některé z kódů, které budete do aplikace zadávat, 
            a míst, kde se budete nacházet, jsou zásadní pro vyústění hry a budou se vám ještě hodit, proto 
            <b>doporučujeme si je zapisovat</b>. Při řešení úkolů nemusíte chodit dál než 200 metrů od místa kde úkol naleznete, 
            pokud ano, bude vám to naznačeno. Dávejte si také <b>pozor na loga</b> naší společnosti, je možné že je někdy budete muset hledat.
        </p>
        <p>
            Za každou nápovědu získáte penalizaci <b>2 minuty</b>, za odhalení řešení <b>5 minut</b>. 
            Za špatnou odpověď získáváte penalizaci <b>1 minutu</b>.
        </p>
        <p>
            Chtěli bychom vás také poprosit, abyste na sebe byli <b>opatrní</b> a dávali pozor na auta. 
            Některá z míst jsou poblíž silnice, přecházejte tedy vždy pouze po vyznačených přechodech.
        </p>
        <p>
            U některých textů uvidíte toto tlačítko: *playIcon* <br />Po jeho stlačení si můžete <b>přehrát zvukovou nahrávku</b> daného textu. 
        </p>
        <p>
            Teď už tedy víte vše potřebné a užijte si hru!  
        </p>
    `,
    continueButtonText: 'Začít hru',
};
